import { render } from "./CouponPanel.vue?vue&type=template&id=3a338183&scoped=true&ts=true"
import script from "./CouponPanel.vue?vue&type=script&lang=ts"
export * from "./CouponPanel.vue?vue&type=script&lang=ts"

import "./CouponPanel.vue?vue&type=style&index=0&id=3a338183&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a338183"]])

export default __exports__